import { render } from "./Boletas.vue?vue&type=template&id=125e720b&scoped=true"
import script from "./Boletas.vue?vue&type=script&lang=js"
export * from "./Boletas.vue?vue&type=script&lang=js"

import "./Boletas.vue?vue&type=style&index=0&id=125e720b&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125e720b"]])

export default __exports__